import React from 'react';
import PropTypes from 'prop-types';

import TextBoxClient from 'client/components/TextBoxClient';
import { bgTypes } from 'styles/generateBgStyleByType';
import ResponsivePicture from 'client/components/ResponsivePicture';
import ImageIcon from '@material-ui/icons/Image';
import { css } from '@emotion/core';
import { useMediaQuery } from '@material-ui/core';
import { belowContain } from 'utils/breakpoint';
import useCoverSettingComponentStyle from 'hooks/useCoverSettingComponentStyle';

const CoverFgImage = ({ desktopImage, mobileImage, onClick, isEditor = false }) => {
    const isXsmScreen = useMediaQuery(belowContain('xsm').replace('@media ', ''));
    const displayImage = isXsmScreen && mobileImage ? mobileImage : desktopImage;
    const showPlaceholder = isEditor && !displayImage;

    return (
        <div css={containerStyle} onClick={onClick}>
            {showPlaceholder ? (
                <div css={[noImageContainerStyle]}>
                    <ImageIcon css={placeholderIconStyle} />
                </div>
            ) : !displayImage ? (
                <></>
            ) : (
                <ResponsivePicture
                    src={displayImage}
                    enableLazyLoad={true}
                    disableMedia={true}
                    haveBlankBlock={false}
                    style={{
                        width: 'auto',
                        height: 'auto',
                        maxWidth: '100%',
                        maxHeight: '100%'
                    }}
                />
            )}
        </div>
    );
};

export default function CoverPage({ onClick = () => {}, content, isEditor = false }) {
    const coverSettingStyle = useCoverSettingComponentStyle();
    const isFgImageOnly = coverSettingStyle.foregroundTab === bgTypes.IMG;

    if (isFgImageOnly) {
        return (
            <CoverFgImage
                desktopImage={coverSettingStyle.foregroundDesktopImg}
                mobileImage={coverSettingStyle.foregroundMobileImg}
                onClick={onClick}
                isEditor={isEditor}
            />
        );
    }

    return (
        <TextBoxClient
            style={{ backgroundColor: 'transparent', cursor: 'pointer' }}
            onClick={onClick}
            content={content}
            ignoreContentPadding
            shouldUseCompressedImg
        />
    );
}

CoverPage.propTypes = {
    onClick: PropTypes.func,
    content: PropTypes.string,
    isEditor: PropTypes.bool
};

const containerStyle = css`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
`;

const noImageContainerStyle = css`
    min-width: 720px;
    min-height: 576px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff3d;
    border: 1px dashed #b6b6b6;
`;

const placeholderIconStyle = css`
    width: 90px;
    height: 90px;
    color: #cccccc;
`;
